module.exports = "//cdn.mxpnl.com/static/asset-cache/2ba95b728ee8c763dc713290ab99dd7a/iron/common/widgets/intro/images/profiles/kathy.svg";